import { useCallback } from 'react'

import { abortBuildRoutes } from '@/features/domain/route/actions/abortBuildRoutes'
import { useNotification } from '@/hooks'
import { useAppDispatch } from '@/store'

import { useController } from './useController'

export function useActions() {
  const { close, updateData } = useController()
  const dispatch = useAppDispatch()
  const toast = useNotification()

  const requestDiscard = useCallback(() => {
    updateData({ showDiscardConfirm: true })
  }, [updateData])

  const cancelDiscard = useCallback(() => {
    updateData({ showDiscardConfirm: false })
  }, [updateData])

  const confirmDiscard = useCallback(async () => {
    try {
      updateData({ discarding: true })
      const result = await dispatch(abortBuildRoutes())
      if (!abortBuildRoutes.fulfilled.match(result)) {
        throw new Error('Internal error')
      }
      close?.()
    } catch (e) {
      toast.error((e as Error).message)
      updateData({ discarding: false, showDiscardConfirm: false })
    }
  }, [close, dispatch, toast, updateData])

  const viewRoutes = useCallback(() => {
    close?.()
  }, [close])

  return { requestDiscard, cancelDiscard, confirmDiscard, viewRoutes }
}
